import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal, openModal } from "../../store/actions/modalAction";
import {
  getRepairingTicketStatusByIdApi,
  updateCustomerInfoApi,
} from "../../apis/repairing.api";
import UpdateCustomerInfoUi from "./UpdateCustomerInfoUi";
import { ReadCustomerInfoAction } from "../../store/actions/readCustomerInfoAction";

const UpdateCustomerInfoController = ({ id, callBack }) => {
  const [fields, setFields] = useState({
    id: id,
    err: "",
    box_id: "",
    customer_name: "",
    country: "",
    state: "",
    city: "",
  });

  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const modalKey = "update-customer-info";
  const title = "Update Customer Information";

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: false,
        value: fields.box_id,
        field: "Box Id",
      },
      {
        required: true,
        value: fields.customer_name,
        field: "Customer Name",
      },
    ],
    [fields]
  );

  const [originalDocument, setOriginalDocument] = useState({});

  const filters = useMemo(
    () => ({
      pageNo: 1,
      pageSize: 10,
      search: "",
      searchable: ["cName"],
      role: "",
      sort: "createdAt",
      sortDirection: -1,
    }),
    []
  );

  const updateFunction = async () => {
    const validationResponse = validate(validationSchemaForUpdate);

    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await updateCustomerInfoApi({ ...fields, country: fields?.country?._id ? fields?.country?._id : fields?.country, state: fields?.state?._id ? fields?.state?._id : fields?.state, city: fields?.city?._id ? fields?.city?._id : fields?.city }),
          async (response) => {
            // await callBack(response, updatedData);
            setFields(response)
            setLoading(false);
            callBack()
            dispatch(ReadCustomerInfoAction((true)))
            dispatch(closeModal());
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          }
        )
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (id) updateFunction();
  };

  const fetchById = useCallback(
    (id) => {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await getRepairingTicketStatusByIdApi({ id }),
          async (response) => {
            setFields({ ...fields, ...response });
            setOriginalDocument(response);
            setLoading(false);
          },
          (err) => {
            setFields({ ...fields, err });
            setLoading(false);
          }
        )
      );
    },
    [dispatch]
  );

  useEffect(() => {
    if (id) fetchById(id);
  }, [id]);

  return (
    <UpdateCustomerInfoUi
      modalKey={modalKey}
      title={title}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
    />
  );
};
export default memo(UpdateCustomerInfoController);
